// app/src/components/CopyToClipboard/index.jsx
import { IconButton, Tooltip } from '@material-ui/core';
import React from 'react';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const CopyToClipboard = ({ text, children }) => {
    const [copied, setCopied] = React.useState(false);

    const handleCopy = () => {
        const textarea = document.createElement('textarea');
        const body = document.getElementsByTagName('body')[0];
        textarea.value = text;
        body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        body.removeChild(textarea);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    return (
        <span onClick={handleCopy}>
            {text}
            <Tooltip
                id="tooltip-copy"
                title="Copy"
                placement="top"
                open={copied}
                classes={{ tooltip: {} }}
            >
                <IconButton aria-label="Copy" size="small">
                    <FileCopyIcon fontSize="small"/>
                </IconButton>
            </Tooltip>
            {copied ? <span>Copied!</span> : children}
        </span>
    );
};

export default CopyToClipboard;

